import React, { useContext } from 'react';
import Layout from './Layout';
import TransitionPreloadPage from "../TransitionPreloadPage";
import { FirebaseProvider, FirebaseContext } from "../../context/firebase";
import { useNavigate } from "react-router-dom";

interface Props {
    name: string;
    settingName: string;
}

const SetupContent: React.FC<Props> = ({ name, settingName }) => {
    const { data, error, loadingGettingUserData } = useContext(FirebaseContext);
    const navigate = useNavigate();

    const backToLogin = process.env.REACT_APP_WEBSITE_HOME_PAGE;

    // Redirect if error
    React.useEffect(() => {
        if (error) {
            window.location.replace(backToLogin || '');
        }
    }, [error]);

    // Render loading / error / layout
    if (error || loadingGettingUserData || !data) {
        return <TransitionPreloadPage />;
    }

    return <Layout name={name} settingName={settingName} />;
};

// Wrap content with provider here
const Setup: React.FC<Props> = (props) => {
    return (
        <FirebaseProvider>
            <SetupContent {...props} />
        </FirebaseProvider>
    );
};

export default Setup;
